import React from 'react'

export default function Announcements() {
  const announcements = [
    {
      id: 1,
      title: 'New: Intervention cost summaries',
      preview: 'Intervention cost summaries are now available in the Reports section. Track spending and resource allocation across all your intervention groups.',
    },
    {
      id: 2,
      title: 'Welcome to the new dashboard',
      preview: 'We\'ve redesigned the dashboard to help you find what you need faster. Check out the quick actions and reminders sections.',
    },
  ]
  
  return (
    <div className="overflow-hidden rounded-2xl bg-white shadow-md border border-gray-100">
      <div className="p-5">
        <h2 className="text-base font-semibold text-gray-800">Announcements</h2>
        <div className="mt-4 space-y-3">
          {announcements.map((announcement) => (
            <div 
              key={announcement.id} 
              className="p-3 bg-gradient-to-r from-blue-50 to-sky-50 rounded-xl border border-blue-100/50"
            >
              <h3 className="text-sm font-semibold text-gray-800">
                {announcement.title}
              </h3>
              <p className="mt-1 line-clamp-2 text-sm text-gray-600">{announcement.preview}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

